// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"clientEditTab_buttonsContainer__kk57W"};